<template lang="pug">
#layout
  ul
    li(v-for='(item,index) in dwgSpaceList' @click='tabchangeSpace(item)'
      :class="{ 'activelayout': item.picName == spaceOfDwgData || item.fileName == spaceOfDwgData }" :key='index')
      template(v-if="mlibEnabled")
        span {{item.fileName}}
        van-image(v-if='item.fileName == spaceOfDwgData' :src='hookImg')
      template(v-else)
        span {{item.picName}}
        van-image(v-if='item.picName == spaceOfDwgData' :src='hookImg')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  data () {
    return {
      hookImg: require("@/CommonDP/mongeView/appView/images/hook.png")
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    spaceOfDwgData() {
      return JSON.parse(mongeApp.map.spaceOfDwgData);
    },
    dwgSpaceList() {
      return mongeApiMlib.getDwgSpaceList();
    }
  },
  mounted () {
    console.log("dwgSpaceList", this.dwgSpaceList);
  },
  methods: {
    tabchangeSpace(item) {
      mongeMutations.setSpaceOfDwgData(this.mlibEnabled ? JSON.stringify(item.fileName) : JSON.stringify(item.picName));
    }
  }
};
</script>

<style lang="scss" scoped>
#layout{
  position: absolute;
  width: calc(100% - 24px);
  margin-left: 12px;
  max-height: 180px;
  background: rgba(0, 0, 0, 0.68);
  border-radius: 5px;
  bottom: 58px;
  overflow: hidden;
  ul{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    li{
      padding: 0 15px;
      width: 100%;
      height: 60px;
      color: #ffffff;
      span{
        font-size: 14px;
        line-height: 60px;
      }
      .van-image{
        width: 20px;
        height: 16px;
        margin-top: 22px;
        float: right;
      }
    }
    .activelayout{
      background: rgba(85, 132, 255, 0.1) !important;
      color: #1278FF !important;
    }
  }
}
</style>
